module.exports = __webpack_public_path__ + "static/media/Dana Vandiver Headshot.70651836.jpeg";